import { render, staticRenderFns } from "./OrderSizeHead.vue?vue&type=template&id=0242a59c&scoped=true"
import script from "./OrderSizeHead.vue?vue&type=script&lang=js"
export * from "./OrderSizeHead.vue?vue&type=script&lang=js"
import style0 from "./OrderSizeHead.vue?vue&type=style&index=0&id=0242a59c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242a59c",
  null
  
)

export default component.exports